import { createContext, useState } from "react";
import {
  allNewsCall,
  allStasCall,
  allVideosCall,
  charByLetterCall,
  latestNewsCall,
  mostSearchedCall,
  charByFieldCall,
  charByIdCall,
  addedRecentlyCall,
  newsByIdCall,
  mostcharByFieldCall,
  characterSliderCall,
  CharByFieldCall_Speciality,
} from "./axiosApis";

export const AppContext = createContext();

export function AppProvider({ children }) {
  const [latestNews, setlatestNews] = useState({
    data: [],
    loading: true,
  });
  const [allNews, setallNews] = useState({
    data: [],
    loading: true,
  });
  const [allVideos, setallVideos] = useState({
    data: [],
    loading: true,
  });
  const [stas, setStas] = useState({
    data: [],
    loading: true,
  });
  const [mostSearched, setmostSearched] = useState({
    data: [],
    loading: true,
  });
  const [charByLetter, setcharByLetter] = useState({
    data: [],
    loading: true,
  });
  const [charByField, setcharByField] = useState({
    data: [],
    loading: true,
  });
  const [charById, setcharById] = useState({
    data: [],
    loading: true,
  });
  const [addedRecently, setaddedRecently] = useState({
    data: [],
    loading: true,
  });
  const [newsById, setnewsById] = useState({
    data: [],
    loading: true,
  });
  const [mostChar, setmostChar] = useState({
    data: [],
    loading: true,
  });
  const [characterSlider, setcharacterSlider] = useState({
    data: [],
    loading: true,
  });
  const [specialities, setSpecialities] = useState({
    data: [],
    loading: true,
  });

  const [searchValue, setSearchValue] = useState("");
  const [searchQuery, setsearchQuery] = useState("");
  const [fieldId, setfieldId] = useState(null);
  const [specialityId, setspecialityId] = useState(null);

  // console.log("IM INSIDE THE CONTEXT")
  const getLatestNews = () => {
    latestNewsCall()
      .then((response) => {
        setlatestNews({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getLatestNews", err));
  };

  const getCharacterSlider = (count) => {
    characterSliderCall(count)
      .then((response) => {
        setcharacterSlider({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getCharacterSlider", err));
  };

  const getSpecialities = (id) => {
    CharByFieldCall_Speciality(id)
      .then((response) => {
        setSpecialities({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getSpecialities", err));
  };

  const getAllNews = () => {
    allNewsCall()
      .then((response) => {
        // console.log("getAllNews",response)
        setallNews({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getAllNews", err));
  };

  const getAllVideos = () => {
    allVideosCall()
      .then((response) => {
        // console.log("getAllNews",response)
        setallVideos({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getAllVideos", err));
  };

  const getStas = () => {
    allStasCall()
      .then((response) => {
        // console.log("getAllNews",response)
        setStas({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getStas", err));
  };

  const getMostSearched = (num) => {
    mostSearchedCall(num)
      .then((response) => {
        // console.log("getMostSearched",response)
        setmostSearched({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getMostSearched", err));
  };

  const getCharByLetter = (seachName, isArabic = true) => {
    charByLetterCall(seachName, isArabic)
      .then((response) => {
        // console.log("getAllNews",response)
        setcharByLetter({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getCharByLetter", err));
  };

  const handleSearch = () => {
    // console.log("handleIconSearch",searchValue)
    // console.log(searchValue);
    setSearchValue("");
  };

  const getCharByField = (searchQuery, fieldId, specialityId) => {
    console.log("we are here");
    console.log("fieldId", fieldId);
    console.log("specialityId", specialityId);
    console.log("searchQuery", searchQuery);
    charByFieldCall(searchQuery, fieldId, specialityId)
      .then((response) => {
        console.log("getCharByField", response);
        setcharByField({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getCharByField", err));
  };

  const getCharById = (id) => {
    charByIdCall(id)
      .then((response) => {
        // console.log("getMosttttttttttttSearched",response)
        setcharById({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getCharById", err));
  };

  const getAddedRecently = (count) => {
    addedRecentlyCall(count)
      .then((response) => {
        // console.log("get added recently", response)
        setaddedRecently({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getAddedRecently", err));
  };

  const getNewsById = (id) => {
    newsByIdCall(id)
      .then((response) => {
        // console.log("get added recently", response)
        setnewsById({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getNewsById", err));
  };

  const getmostChar = () => {
    mostcharByFieldCall()
      .then((response) => {
        setmostChar({
          data: response,
          loading: false,
        });
      })
      .catch((err) => console.log("err in getmostChar", err));
  };

  return (
    <AppContext.Provider
      value={{
        latestNews,
        getLatestNews,
        allNews,
        getAllNews,
        allVideos,
        getAllVideos,
        stas,
        getStas,
        mostSearched,
        getMostSearched,
        charByLetter,
        getCharByLetter,
        charByField,
        getCharByField,
        charById,
        getCharById,
        addedRecently,
        getAddedRecently,
        newsById,
        getNewsById,
        mostChar,
        getmostChar,

        setSearchValue,
        handleSearch,
        searchValue,

        searchQuery,
        setsearchQuery,

        getCharacterSlider,
        characterSlider,

        getSpecialities,
        specialities,

        fieldId,
        setfieldId,
        specialityId,
        setspecialityId,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
